
import {connect} from 'react-redux';
import axios from 'axios';
import {Alert, Platform} from "react-native";

import ListMicroConsumptionSatiaScreen from "../../../../satia/main/internetUsage/ListMicroConsumptionSatiaScreen";
import store from "../../../../../redux/store";
import i18n from "../../../../../I18n/i18n";
import {typeExport} from "../../../../../redux/store/type";
import HMAlert from "../../../../../customviews/HMAlert";

const mapStateToProps = (state) => ({
    // item_count: state.reducerSplashSatiaScreen.results.item_count,
    DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

    response: state.reducerListMicroConsumptionSatiaScreen.response,
    Credits: state.reducerListMicroConsumptionSatiaScreen.Credits,
    resultsAll: state.reducerListMicroConsumptionSatiaScreen.resultsAll,
    results: state.reducerListMicroConsumptionSatiaScreen.results,
    NoInternetDialog: state.reducerListMicroConsumptionSatiaScreen.NoInternetDialog,
    isLoading: state.reducerListMicroConsumptionSatiaScreen.isLoading,
    lazyload_end: state.reducerListMicroConsumptionSatiaScreen.lazyload_end,
    showRefresh: state.reducerListMicroConsumptionSatiaScreen.showRefresh,
    failed: state.reducerListMicroConsumptionSatiaScreen.failed,
    page: state.reducerListMicroConsumptionSatiaScreen.page,
    empty: state.reducerListMicroConsumptionSatiaScreen.empty,
    DataSplashScreen: state.reducerSplashSatiaScreen,
    resultsSet: state.reducerListMicroConsumptionSatiaScreen.resultsSet,
    isLoadingSet: state.reducerListMicroConsumptionSatiaScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerListMicroConsumptionSatiaScreen.NoInternetDialogSet,
    ListFilter: state.reducerListMicroConsumptionSatiaScreen.ListFilter,
    id: state.reducerListMicroConsumptionSatiaScreen.id,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id, func) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id, func)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callserviceActionListCredits: () => dispatch(serviceActionListCredits()),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id, func) => {

    let pagee;
    let url_send = "";

    switch (type) {
        case typeExport.TypeGetListMicroConsumptionSatiaScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            page === 1 ? dispatch(serviceActionRefresh()) : dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetListMicroConsumptionSatiaScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }


    let formData = new FormData();
    formData.append('beginDate', params.beginDate);
    // // formData.append('lang', params.lang);
    formData.append('endDate', params.endDate);
    formData.append('token', store.getState().reducerSplashSatiaScreen.token == null ? '' : store.getState().reducerSplashSatiaScreen.token);
    formData.append('page', params.page);

    formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

    // formData.append('type', params.type);
    // formData.append('listFilter',JSON.stringify(params.listFilter) );
    // formData.append('trackingCode', params.trackingCode);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
        }
    };
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
  //  axios.post(url, formData, config)
        .then(async response => {

            let dataResponse = response.data;
            let dataAll = dataResponse.result && dataResponse.result.data ? dataResponse.result.data : dataResponse.result;

            switch (type) {

                case typeExport.TypeGetListMicroConsumptionSatiaScreen:


                    if (dataResponse.status) {


                        let data = dataAll.details;


                        if (dataAll && dataAll.credit && dataAll.credit.length > 1) {
                            dispatch(serviceActionListCredits(dataAll.credit));

                        }
                        //let credits = dataAll.details;
                        //    dispatch(serviceActionListFilter(dataResponse.result.searchItems));

                        if (data == null) data = []
                        /*   let arr = store.getState().reducerListMicroConsumptionSatiaScreen.results
                           if (page == 1) {
                               arr = data
                               global.list_menu_shahrdar=dataResponse.result.menu
                           } else {
                               if (arr.length > 0)
                               //    arr.push(data);
                                   arr = [...arr, ...data]
                               else
                                   arr = data
                           }*/

                        if (data.length == item_count) {
                            pagee = page + 1;
                            dispatch(serviceActionSuccess(data, pagee, dataAll, dataResponse));
                        }

                        else {
                            (page === 1 & (data.length == 0)) ?
                                dispatch(serviceActionEmpty(page, dataAll, dataResponse))
                                :
                                (pagee = page + 1, dispatch(serviceActionEnd(data, pagee, dataAll, dataResponse)));
                        }

                        func ? func() : null;

                        // let t=((getState === null || getState === undefined || getState === '') ? id : getState.route.params.data.type);
                        // await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListMicroConsumptionSatia +  t, arr)
                        // if (page == 1)
                        //     await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListMicroConsumptionSatiaFilter + t, dataResponse.result.searchItems)

                    } else {
                        // dispatch(serviceActionSuccess(null, pagee, null, dataResponse));

                        dispatch(serviceActionResponse(dataResponse));

                        HMAlert(
                            i18n.t('constant.message'),
                            dataResponse.message,
                            [
                                {
                                    text: i18n.t('constant.ok'),
                                    onPress: () => {


                                    }
                                },

                            ],
                            {cancelable: true}
                        )

                        //  dispatch(serviceActionError(response, page))

                        //alert(dataResponse.message)
                    }

                    break;

                case typeExport.TypeSetListMicroConsumptionSatiaScreen:
                    if (dataResponse.status)
                        dispatch(serviceActionSuccessSet(dataResponse, id))
                    else
                        dispatch(serviceActionError("error", page))
                    //    alert(dataResponse.message)
                    break;
                default:
                    console.log("default")
            }
        }).catch((e) => {
        switch (type) {
            case typeExport.TypeGetListMicroConsumptionSatiaScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetListMicroConsumptionSatiaScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id, func) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id, func);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     }
        // )

        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id, func);
        } else {
            switch (type) {
                case typeExport.TypeGetListMicroConsumptionSatiaScreen:
                    dispatch(serviceActionError('error_Connection', page))

                    break;
                case typeExport.TypeSetListMicroConsumptionSatiaScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))
                    break;
                default:
            }
        }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetListMicroConsumptionSatiaScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetListMicroConsumptionSatiaScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetListMicroConsumptionSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    isLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false,
})

export const serviceActionError = (error, page, response) => ({
    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    isLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error,
    response: response,
})
export const serviceActionRefresh = () => ({
    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    isLoading: false,
    empty: false,
    failed: false,
    page: 1,

})
export const serviceActionSuccess = (data, page, resultsAll, response) => ({

    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    isLoading: true,
    empty: false,
    failed: false,
    page: page,
    resultsAll: resultsAll,
    response: response,
})
export const serviceActionEnd = (data, page, resultsAll, response) => ({
    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    isLoading: false,
    empty: false,
    failed: false,
    page: page,
    resultsAll: resultsAll,
    response: response,
})
export const serviceActionEmpty = (page, resultsAll, response) => ({
    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    isLoading: false,
    empty: true,
    failed: false,
    page: page,
    resultsAll: resultsAll,
    response: response
})
export const serviceActionAddFirstData = (data, item_count, resultsAll, response) => ({
    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    isLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2,
    resultsAll: resultsAll,
    response: response

})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_AddSubList,

    data: data,

})

export const serviceActionListFilter = (data) => ({

    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_LIST_FILTER,

    ListFilter: data,

})
export const serviceActionListCredits = (data) => ({

    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_CREDITS,

    Credits: data,

})
export const serviceActionResponse = (data) => ({

    type: typeExport.ListMicroConsumptionSatiaScreen_SERVICE_RESPONSE,

    response: data,

})

export default connect(mapStateToProps, mapDispatchToProps)(ListMicroConsumptionSatiaScreen);
